import { createContext, useContext } from "react";

// For use by <FloSelect>
export const IsInModalContext = createContext(false);
export function useIsInModal() {
  return useContext(IsInModalContext);
}
